import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/7c680545/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const InlineNotification = makeShortcode("InlineNotification");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const DoDontExample = makeShortcode("DoDontExample");
const Caption = makeShortcode("Caption");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`Axes and labels provide critical context for the information within a chart. Use simple, easy-to-understand descriptors and metrics to label your chart and axes.`}</p>
    </PageDescription>
    <InlineNotification mdxType="InlineNotification">
      <p><strong parentName="p">{`Note:`}</strong>{` This guidance is a work in progress. To see our roadmap, make feature requests, or contribute, please go to the carbon-charts `}<a parentName="p" {...{
          "href": "https://github.com/carbon-design-system/carbon-charts"
        }}>{`GitHub repository`}</a>{`.`}</p>
    </InlineNotification>
    <AnchorLinks mdxType="AnchorLinks">
      <AnchorLink mdxType="AnchorLink">Starting at zero</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Gap in data</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Breaks in axes</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Time series</AnchorLink>
    </AnchorLinks>
    <h2 {...{
      "id": "starting-at-zero"
    }}>{`Starting at zero`}</h2>
    <p><strong parentName="p">{`Always start numerical axes at zero for part-to-whole and comparisons charts.`}</strong>{` For bar and area charts, a truncated Y-axis can distort the perceived scale of a chart, making a small difference appear more significant than it is.`}</p>
    <Row mdxType="Row">
      <Column colLg={4} colMd={4} colSm={4} mdxType="Column">
        <DoDontExample type="do" caption="For bar charts, the numerical axis should start at zero." mdxType="DoDontExample">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAACsElEQVQ4y52UWW/TQBDH8xkRLwghAQ9IqNwCxKFADyREBa2KBPSBh36KAhWU8lBBQ0IrKkobJ01QmqPEjh3H9trr48/u+kwUqS22Rp69fnPsjHNBEOAo4U/8PerJHWfTcWECyDdbFoFt26CUCvE8D47jgBAbLtNP4jkD+vj56wcKhQ0UiyWUSiXs7OxgfX0dX9Y+Y29780Se5zw3wO43FYO+CdM0YBgGBkwspvcMG6tVnUVggTDhUQidEPi+P95D1/HxaamJv20FqqZC13XIMtPlLpqqhbfbBEpPRU9RoGkaW5PR7XZFWmJgVoYuhecvtvy/l5WLJ7nFVrMF27Gwu6HB0Ck/Ai8ywL/CGNtPPB8WDXXfD8Q8l8TDTqcD13URG5zPS3i9pgndZ5P7pT5XIJYHLh48q2OtTUMvI89iYwLYaDSiRIeLz6eqeLTcS8JYeCih8McODyoOzl76jZVWCCSWB1ujETQCSpIkbjf28MVkFU/ep8C7t8t4+VUPQ+85uHhtDyvNENKRDCzM1qGG4YTAer0uCllR+LSFuekapt8pCfA+Ay4WBkJ3mYfnr3CgI8b9qoFTE3v4rrlp6/EcciB1/cTDmYyH9xjwTQT0EmDoYX/fxJkbZWwNvBRYqVRYUZtpyFPDwKyHHHjh6gjwehmbegbIc5gFzuYrmFxWE+Cdm2W82giBfo/i3OVdfGi5EdDCaRby5sBP65CXDH9sm1slWJyrYv5jl5UBy5Pv4OmMhKUiN0BhHRq4lS9jtWGKsVzRMPFYwpZKRBENdQoH826RZRVdRUsKttk8hKaHHlKH4uCgA4P1dMDWeO4bbGxTmoac/R2FLegISce2+HHww/wHYROLGYp6mb2EmMn5XLYnR8HZcbvdEbmu1WrMgJv2cjDc27lxzT4OPLpvdG88/gdVgPBfy6LbZgAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Legends bahvior highlight on hover",
              "title": "Legends bahvior highlight on hover",
              "src": "/static/a294edd9b669ccba36970d7c261cf02f/09548/axislabel-zero-a.png",
              "srcSet": ["/static/a294edd9b669ccba36970d7c261cf02f/d6747/axislabel-zero-a.png 288w", "/static/a294edd9b669ccba36970d7c261cf02f/09548/axislabel-zero-a.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </DoDontExample>
      </Column>
      <Column colLg={4} colMd={4} colSm={4} mdxType="Column">
        <DoDontExample type="dont" caption="When an axis starts at non-zero, percentage differences between bars are exaggerated." mdxType="DoDontExample">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAACk0lEQVQ4y5VUW2sTQRTOHxX0UVAQEXxqrRYVrLUP4kNBtD4XBBHrra0XCLQ1qWBpSJqkCU1z62YvyV5ndmc/55JNsjHSdpazO2dn5jvfuU0mjmOcJ2Ik3/NG5iKbLgomAcVmz/MRBAEopVKiKAIhBL4fIOTzyzDngAx/Dvext7eLXC6PfD6PQqGAbDaLH9+/oXTw+1LMM1EYo7hjwu67cF0HjuPA5uLxueEE2K4OuAcefC7CCzn3fTDGZjMMCcPWWhNnbR2mZWIwGKDX43NdQ9P08PLAh26YMHQdlmXxtR40TZNhSQAnJZUUEb/E8vmJku/ZSRFDWGw1WwiIh9KuBc+m8kDEDbChxFyEzidyjbExM7meMOx0OgjDcGTl7dIx+l0ydomlM2vQGLqXjmHK5UajMQy0Anzx8BirPy05FyySEQ0Pi7V3VV/9YzMAy+WyzG6SsKV7Fcx/MBQg//lr4wyUDBmZFNdulrDZpv8HrNfrspA1Teeah5UHNSx+HAOuP6qCeCqrzCC4eqOELy0V4zBi0ot/Yqg6RR1aXqhi8ZMxcnX9aQ3WQMU4NhTDry3FMKmJJEESsFKp8KJ2Ry4v308Dzt89wtq+rVzUSQow8CPYpmKbiqEATMaTuQoWNsyRfudWCc937KHLFFeuF/G5pRifFF1svTpVxkKm6jApmX7fljFcfXaMlU2NG+WlwwgeL5bxJicMUHhdB7fnjrDdcKVeL5h4//oEIX8Yj2eqUwRLypPT61nQdGtU0M1ml8dQMaSE4vS0A4f3tCh0oZ9wPSB0fB9OFq1qQSJlrAfy4hCVIJIX+B43NOxl/vi+Ozqfmb7bJoEn9Xa7I2Ndq9W4gXDcJXH6OsvMut9mAU/vm96b6H8BakQALxf6wPgAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Legends bahvior highlight on hover",
              "title": "Legends bahvior highlight on hover",
              "src": "/static/bcfb0a04f835e8e97ef8e3783483a34a/09548/axislabel-zero-b.png",
              "srcSet": ["/static/bcfb0a04f835e8e97ef8e3783483a34a/d6747/axislabel-zero-b.png 288w", "/static/bcfb0a04f835e8e97ef8e3783483a34a/09548/axislabel-zero-b.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </DoDontExample>
      </Column>
    </Row>
    <p><strong parentName="p">{`It’s acceptable to start line charts and scatter plots at a value higher than zero.`}</strong>{` These types of visualizations are less sensitive to distortion because they communicate trends rather than difference in size or quantity. In these cases, cropping the Y-axis helps users better identify the direction of change.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAABQklEQVQoz41T0W7DIAzs///cnttt0pSkIZq6NCmQgMHcgJak7RpplpyD+DhsA7sQAv5rhZvwlSfbpU/f92jbFkIIHI/HPK6qCk3ToOs61HWNeZ4fRLc2zIJEBCkljDF54b2nf8m995uZ/cmwiG6Zd9sizCsuguM4Qim1kgp6zqT2YHE5+VQUAj+JorQgrCVnQa3yzxIoJZDx+HrzEIckeN3gXtQRQ48esndrhsMwQEm1EK6ZhUzqPhy+P4HunfPcE982BmbFaPcEsWecBa+CzB6TMugF4adx6FvCuSOcKodzyxi66HFBmieXPWGSLvNzXATo4SZYSpMXCS1tLJFhtIOdPOzs8nzWlNHG8hMmMX2hmKGHmSjyIte4R0FrbTwMf2svL40uqGOPLdkXd48XXA7l/rLmcSivYY0x81MsPLycYr+FmV/P9+wMaQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Gap in data denoted by texture",
            "title": "Gap in data denoted by texture",
            "src": "/static/a581b73d69b17d50d3f54dbbf5c7550d/fb070/axislabel-zero-c.png",
            "srcSet": ["/static/a581b73d69b17d50d3f54dbbf5c7550d/d6747/axislabel-zero-c.png 288w", "/static/a581b73d69b17d50d3f54dbbf5c7550d/09548/axislabel-zero-c.png 576w", "/static/a581b73d69b17d50d3f54dbbf5c7550d/fb070/axislabel-zero-c.png 1152w", "/static/a581b73d69b17d50d3f54dbbf5c7550d/fb755/axislabel-zero-c.png 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  For line charts showing stock market activities, the existence of peaks and
  valleys in trends is more important than the true size of the change.
        </Caption>
      </Column>
    </Row>
    <h2 {...{
      "id": "gaps-in-data"
    }}>{`Gaps in data`}</h2>
    <p>{`Use the designated texture to denote the range or period when data is not available. Always label both start and end points where data is not available.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAABIElEQVQoz41TC66EIAzc+5/TGGNiImr5tTiPwsJq8txskwqhw3Ta4us8T/xn7VzXX13tpZ9lWTCOI6ZpwjAMmOf5RnrPhEdTfCGMMcIYA2stnHPw3t8yp5S6/6RQCZVIRHq2dAFqPMYA7wJiqJiUvhCu61rUMfOtb2rCCY4yEUeEEEAm9tofCbVcIsoKL4TvZtmNqzJVmUm9Yxwrwx1cMB/s+emhMSv2bYezNXuSBI6pXPKWwVLVhVy2sIBDjQUnvQrFd4VkCZYcaAuwu2TPRCTFWw+VUNfr5MmoUilrJ2wAnax1lANSLnIuL6W615j2VwenrdF9TZLbELgP7UZYDsO75Pw8dOLXJ3McR1HZnlQ7b3iN9ZKvZTz9Oe3yN9O7fzp2ZAAnmY6RAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Gap in data denoted by texture",
            "title": "Gap in data denoted by texture",
            "src": "/static/a8305a56888e9ff96450c2c80a6d2832/fb070/axislabel-gap.png",
            "srcSet": ["/static/a8305a56888e9ff96450c2c80a6d2832/d6747/axislabel-gap.png 288w", "/static/a8305a56888e9ff96450c2c80a6d2832/09548/axislabel-gap.png 576w", "/static/a8305a56888e9ff96450c2c80a6d2832/fb070/axislabel-gap.png 1152w", "/static/a8305a56888e9ff96450c2c80a6d2832/fb755/axislabel-gap.png 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <h2 {...{
      "id": "breaks-in-axes"
    }}>{`Breaks in axes`}</h2>
    <p>{`Sometimes it’s useful to skip part of the axis to bring data on the extreme ends into view without distortion. When axes contain a break, use a sinusoidal line to replace the straight axis line.`}</p>
    <p>{`On the X-axis, the break may be fluid with graph area size, with a minimum width of 16px. On the Y-axis, we recommend fixing the distance break at 16px.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAABPUlEQVQoz51S2WoDMQzM//9UX9pSaKAEWuhbIexB9t5sfMjX1PKyu0mhD4lAHtsyo7GkXQgBf43vHnG2HS91XSPPcxRFgaZpbkjvMX6fCIkI4zhCSQmpCX4helQhH4yxcefxUVkI49FKB+sfJOz7Hm3XwVvCZ6UhyOIroowYfCS2szu34bVbaxOuhPxdIVXcOTxnhEtU+JZTUuqiSqTsdygchmElfMlmovfSoBIeh8okPuPDWvj/GrI2heUqrWMJDZ6OGmft8JppZKPBvtQ4RjycKNX1uzEp3giLUTlQLAGfnfezwiWjc/F71uCnniCURjEonJXB6awwCEI9EbpJoegF2kmjvRDKUcWpMDh28raGCymv3BjvXep4uglzZnmZ0liBY+E6xui2OVzJwlL8dQQ3Z/r4pevEy/2Gc+wXjbxgO97Z3kEAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Gap in data bar chart",
            "title": "Gap in data bar chart",
            "src": "/static/55cb5449863f32a344a7d51d17158531/fb070/axislabel-break-3.png",
            "srcSet": ["/static/55cb5449863f32a344a7d51d17158531/d6747/axislabel-break-3.png 288w", "/static/55cb5449863f32a344a7d51d17158531/09548/axislabel-break-3.png 576w", "/static/55cb5449863f32a344a7d51d17158531/fb070/axislabel-break-3.png 1152w", "/static/55cb5449863f32a344a7d51d17158531/fb755/axislabel-break-3.png 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <p>{`If data is available during an axis break, restyle line segments to use 0.5px stroke and hide circles representing data points.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAABG0lEQVQoz5VTi26DMAzs///nWlDFCK8kJDY325CSrtq6RTpM7MvlhM1l2zb8trT+V+i66ON+v+N6veJ2u6FtW4tN06DrukoUb5fyTHBdV4zjaDHGiBCCRd3bzf91mFIygR/uxbIy+I0YcyXY9z2maTqLVVR3H46xJDZxfnF1QPdF0DmHeZ4fjmqyF6EhMCZxWXK1q5UYo9RcpNOhE4fDOEFdR9pAvB/oPKMLuzPND5EtlrWkzeoaE/Ep6JcFw+zx6QkuEHqfDfNK4oINJJjExXDUXcjCz9gkX2CCpTuLiGpjmDJy3kE5gYjs+ybpOMs7Sd7HhPlAloamtPOfBHVE1Ek9AnVNx6ocqifgO/dSb04aXojlsue/B08cjV9kIGPl2JBCDgAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Gap in data denoted by texture",
            "title": "Gap in data denoted by texture",
            "src": "/static/219dd87db4996ecc484c3f8c7a6a0efd/fb070/axislabel-break-1.png",
            "srcSet": ["/static/219dd87db4996ecc484c3f8c7a6a0efd/d6747/axislabel-break-1.png 288w", "/static/219dd87db4996ecc484c3f8c7a6a0efd/09548/axislabel-break-1.png 576w", "/static/219dd87db4996ecc484c3f8c7a6a0efd/fb070/axislabel-break-1.png 1152w", "/static/219dd87db4996ecc484c3f8c7a6a0efd/fb755/axislabel-break-1.png 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <p>{`If data isn’t available between break points, denote the data gap with a texture.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAABIElEQVQoz41Ti26EMAy7//9Q4MRg0AP6rhcXyjrGpqtkHBLFzQMeKSX8dxh/FzwPPvq+R9M0aNsWz+czc9d1GIbhRhy/UMezoLUWSqnMxhhorTMTMUZoF+AjM+8RRWiPHxU657LY9YQQ4MSvrcNsIj51EA7QPsIK1OEjlPhPwXEcMygQgkcUkI2I8SJeyJhxPmPWDuPq8NIeVt6dZ04lOE0TlmXJDuNTvv1lBZLo3S6YfgytwrGQWLdMQfVaYEPCJG0QmwizSop5qeCdjZ+C27ZCrRofK1uNkPqRZBlslwsiczlse+dvu/ZnwaK8rlKhNbkazoRc5sdx0GaiP2IFpYPSxSlYqqjLLx8Zk+Z5PpOuH32xz5bv/pbrbP6y63zyFxRXY07/eNYAAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Gap in data denoted by texture",
            "title": "Gap in data denoted by texture",
            "src": "/static/3f9a3f694c649fbb03b78af7e56d0c78/fb070/axislabel-break-2.png",
            "srcSet": ["/static/3f9a3f694c649fbb03b78af7e56d0c78/d6747/axislabel-break-2.png 288w", "/static/3f9a3f694c649fbb03b78af7e56d0c78/09548/axislabel-break-2.png 576w", "/static/3f9a3f694c649fbb03b78af7e56d0c78/fb070/axislabel-break-2.png 1152w", "/static/3f9a3f694c649fbb03b78af7e56d0c78/fb755/axislabel-break-2.png 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <h2 {...{
      "id": "time-series"
    }}>{`Time series`}</h2>
    <h4 {...{
      "id": "consistent-increments"
    }}>{`Consistent increments`}</h4>
    <p>{`If any form of axis compression is required, use the provided `}<a parentName="p" {...{
        "href": "#breaks-in-axes"
      }}>{`axis break`}</a>{` styling to visually denote the compression.`}</p>
    <h4 {...{
      "id": "localization"
    }}>{`Localization`}</h4>
    <p>{`In time series, X-axis labels reflect the time increment in the data. When possible, use localized date and time format, or user preference. Otherwise, the chart defaults to the format presented below.`}</p>
    <h4 {...{
      "id": "landmark-labels"
    }}>{`Landmark labels`}</h4>
    <p>{`Whenever data cross into a new time cycle, such as a new day, month, or year, semibold the label to emphasize the transition.`}</p>
    <Row mdxType="Row">
      <Column colLg={12} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "45.96340150699677%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsSAAALEgHS3X78AAAA9UlEQVQoz5VSi27EIAzj/78Vqq4tBAiQi+HguttN2iJZPEIcYzClFIkxdqSUOphZEK01hfwrDAistbJtW4dzTrz3z3S7EQ/UWr+t32Gg7LquH508ZaHIwmUQgDznrOrzavaR8DxPVeaWklFYJBBL5qLELD5knVcpagVR6jlAfiO01qmaUcxaiLHWl3mljr2gZFCJdUyj6bDlBRNCkK/j6OazKrrCuCqS8Ovu2XyweRNK3M8n3EhritpjoAAq4SO65zxemojWq88fgHHfd4GIlUtZjpN0Lwp+TCf0PqzOd0VzjoMzD7L7mRnLw/aHjwZC4FO8Ez8AwoTFloBpeI0AAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Gap in data denoted by texture",
            "title": "Gap in data denoted by texture",
            "src": "/static/e855c58487c91c6dcf3b5c3b436752de/fb070/axislabel-timeseries.png",
            "srcSet": ["/static/e855c58487c91c6dcf3b5c3b436752de/d6747/axislabel-timeseries.png 288w", "/static/e855c58487c91c6dcf3b5c3b436752de/09548/axislabel-timeseries.png 576w", "/static/e855c58487c91c6dcf3b5c3b436752de/fb070/axislabel-timeseries.png 1152w", "/static/e855c58487c91c6dcf3b5c3b436752de/fb104/axislabel-timeseries.png 1728w", "/static/e855c58487c91c6dcf3b5c3b436752de/4996e/axislabel-timeseries.png 1858w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a time series plotted at 15 seconds intervals</Caption>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      